import { withInstall } from '@element-plus/utils/with-install'
import InputNumber from './src/input-number.vue'

export const ElInputNumber = withInstall(InputNumber)

export default ElInputNumber
export * from './src/input-number'
